import { render, staticRenderFns } from "./AbstractMenu.vue?vue&type=template&id=081f6325&scoped=true&"
import script from "./AbstractMenu.vue?vue&type=script&lang=js&"
export * from "./AbstractMenu.vue?vue&type=script&lang=js&"
import style0 from "./AbstractMenu.vue?vue&type=style&index=0&id=081f6325&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081f6325",
  null
  
)

export default component.exports